import abstractHeaderWidget from "../../core/chrome/abstractHeaderWidget.js";
import responsive from "../../core/responsive.js";
import session from "../../core/session.js";
import theme from "../../core/theme.js";

/**
 * `accountingHeaderWidget` is the header widget used in
 * accounting. It handles scrolling of the viewport to update the
 * header's title on scroll.
 */
function accountingHeaderWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = abstractHeaderWidget(spec, my);

	let title;
	let mainBrush;

	my.showWkHeader = spec.showWkHeader;

	that.setDocument = function (newDocument, hasMarketingLayer = false) {
		// Todo: use supercall when moving to klassified
		my.document = newDocument;
		my.document.onUpdateActions.register(that.update);

		my.hasMarketingLayer = hasMarketingLayer;

		that.update();
	};

	that.update = function () {
		if (!mainBrush) {
			return;
		}

		mainBrush.asJQuery().empty();
		mainBrush.render(my.renderHeaderOn);
	};

	that.getTitle = function () {
		return title && title.asJQuery().text();
	};

	that.setTitle = function (newTitle) {
		if (!title) {
			return;
		}
		title.asJQuery().empty();
		title.render(newTitle);
	};

	that.renderContentOn = function (html) {
		if (!my.visible) {
			return;
		}

		const headerClass = my.showWkHeader
			? "modal-wk-header"
			: "navbar-fixed-top";

		mainBrush = html.div(
			{
				id: "main-navbar",
				class: ["navbar", "no-right-menu", headerClass],
			},
			my.renderHeaderOn,
		);
	};

	my.renderHeaderOn = function (html) {
		if (hasNavigation()) {
			html.div({
				id: "leftmenu-toggler",
				"data-test": "leftmenu-toggler",
			}).click(() => {
				that.onLeftTogglerClick.trigger();
			});
		}

		html.div({ id: "brand-name" }, (html) => {
			title = html.h1(getTitleText());
		});

		html.div({
			id: "rightmenu-toggler",
			class: ["menu-toggler", { "mobile-only": !hasActions() }],
			"data-test": "rightmenu-toggler",
		}).click(that.onRightTogglerClick.trigger);

		renderHeaderActionsOn(html);
		my.renderLoadingOn(html);
		my.renderAutoSaveOn(html);
	};

	function renderHeaderActionsOn(html) {
		if (!that.getDocument()) {
			return;
		}

		html.div({ class: "navbar-form" }).render((html) => {
			that.getDocument().renderTopActionsOn(html);
		});
	}

	function hasNavigation() {
		const document = that.getDocument();
		if (!document) {
			return true;
		}
		return document.hasNavigation();
	}

	function hasActions() {
		const document = that.getDocument();
		if (!document) {
			return false;
		}
		return (
			document.hasActionsMenu() &&
			!document.isActionsMenuMobileOnly() &&
			!my.hasMarketingLayer
		);
	}

	function getTitleText() {
		const document = that.getDocument();
		const currentCompany = session.getCompany();
		const isMobile = responsive.isMobileOrIPadPortaitBreakpoint();
		const agencyName = session.agency && session.agency.name;

		if (document && document.headerTitle) {
			return document.headerTitle;
		}

		const brandingName = theme.brandingName || agencyName || "V3";
		const companyName =
			(currentCompany && currentCompany.getName()) || "Företagsplatsen";

		if (isMobile) {
			return `${companyName} — ${brandingName}`;
		}
		return `${brandingName} — ${companyName}`;
	}

	return that;
}

export default accountingHeaderWidget;
